import { type Nullable } from 'apps/core/types/global.types';
import { type PageFilterOptions } from 'store/slices/page';

export const updateFilterOptions = (
  filterOptions: Nullable<PageFilterOptions>,
  filterId: string,
  value: string | number | boolean | null | undefined,
) =>
  filterOptions?.map((filter) => {
    if (filter.id === filterId) {
      return { ...filter, value: value ?? '' };
    }
    return filter;
  }) ?? [];

export const mapFilterOptionsToRecordString = (
  filterOptions: Nullable<PageFilterOptions>,
): Record<string, string> | undefined => {
  if (!filterOptions) return;

  return filterOptions.reduce<Record<string, string>>((acc, { id, value }) => {
    if (Array.isArray(value)) {
      return {
        ...acc,
        [id]: value.join(','),
      };
    }

    return {
      ...acc,
      [id]: (value ?? '').toString(),
    };
  }, {});
};

export const mapFiltersStorageKeyToFavoriteFiltersStorageKey = (key: string): string => `${key}_FAVORITE`;
